import _ from 'underscore';
import { useContext, useCallback } from 'react';
import { EnvironmentContext } from '../environment/context';

export function useCleanAllCache() {
  const [, environments] = useContext(EnvironmentContext);

  const cleanAllCache = useCallback(() => {
    _.each(environments, environment => {
      if (environment) {
        const { store } = environment;
        const allRecordGroups = store.recordGroups;
        _.each(allRecordGroups, recordGroup => {
          const allRecords = recordGroup && recordGroup.records;
          const allRecordsIdsToRemove = _.pluck(allRecords, 'id');
          if (allRecordsIdsToRemove && allRecordsIdsToRemove.length > 0) {
            recordGroup.deleteRecords(allRecordsIdsToRemove);
            recordGroup.notify('entitiesDeleted', allRecordsIdsToRemove);
          }
        });
      }
    });
  }, [environments]);

  return cleanAllCache;
}
